import type { RunResult, TestCase, TestResult } from './protocol';

export function compareTest(test: TestCase, run: RunResult): TestResult {
	const normalize = (text: string) =>
		test.normalizeWhitespace ? text.trim().replace(/\s+/g, ' ') : text;
	const outputMatches = normalize(run.stdout) === normalize(test.expectedStdout);
	const exitMatches = run.exitCode === test.expectedExitCode;
	return {
		testId: test.id,
		passed: run.status === 'exited' && outputMatches && exitMatches,
		run,
		outputMatches,
		exitMatches,
	};
}

export function createTest(): TestCase {
	return {
		id: crypto.randomUUID(),
		name: 'New test',
		stdin: '',
		expectedStdout: '',
		expectedExitCode: 0,
		timeoutMs: 5000,
		normalizeWhitespace: false,
	};
}
